var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.applySorting}},[_c('div',{staticClass:"arrow-up mb-1",class:{'focus-up': _vm.isSorting && !_vm.value.invert }}),_c('div',{staticClass:"arrow-down",class:{'focus-down': _vm.isSorting && _vm.value.invert }})])}
var staticRenderFns = []

export { render, staticRenderFns }